import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { AppNgMaterialModule } from '../app-ng-material.module';
// External State Entity Components
import { ExternalStateEntityEditComponent } from './external-state-entity/external-state-entity-edit/external-state-entity-edit.component';
import { ExternalStateEntityDeleteComponent } from './external-state-entity/external-state-entity-delete/external-state-entity-delete.component';

// State Group Details Components
import { StateGroupAddComponent } from './state-group-details/state-group-add/state-group-add.component';
import { StateGroupEditComponent } from './state-group-details/state-group-edit/state-group-edit.component';
import { StateGroupDeleteComponent } from './state-group-details/state-group-delete/state-group-delete.component';
import { StateGroupAssignComponent } from './state-group-details/state-group-assign/state-group-assign.component';

// Service
import { StateEntityGroupsService } from './state-entity-groups.service';

@NgModule({
  declarations: [
    ExternalStateEntityEditComponent,
    ExternalStateEntityDeleteComponent,
    StateGroupAddComponent,
    StateGroupEditComponent,
    StateGroupDeleteComponent,
    StateGroupAssignComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    AppNgMaterialModule
  ],
  providers: [StateEntityGroupsService],
  schemas: [NO_ERRORS_SCHEMA],
  exports: [
    ExternalStateEntityEditComponent,
    ExternalStateEntityDeleteComponent,
    StateGroupAddComponent,
    StateGroupEditComponent,
    StateGroupDeleteComponent,
    StateGroupAssignComponent
  ]
})
export class StateEntityGroupsModule { }
